import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import moment from 'moment';
import RevistasFilter from './RevistasFilter';
import RevistasIssuu from './RevistasIssuu';
import RevistasItems from './RevistasItems';
import useAPIError from '../../hooks/useAPIError';
import { RevistaObj } from '../../types/Types';
import { RevistaService } from '../../services';
import { useAuthStore } from '../../store/AuthContext';
import NoData from '../../components/NoData';

const defaultRevista: RevistaObj = {
  idRevista: 0,
  idIssu: '',
  codIdioma: 0,
  fechaInsercion: '',
  pathPortada: '',
  pathVisualizacion: '',
  pathDescarga: '',
  mesDeRevista: '',
  fechaInsercionAfterJunio2019: false,
};

const RevistasCaprabo: FC = () => {
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  // hooks de traducciones
  const { addError, addErrorBack } = useAPIError();
  // hooks de para el tratamiento de errores

  const [years, setYears] = useState([] as number[]);
  const [yearSelectActual, setYearSelectActual] = useState(
    parseInt(sessionStorage.getItem('yearRevistas') as string, 10),
  );
  const [revistasData, setRevistasData] = useState<RevistaObj[]>([]);
  const [revistaTop, setRevistaTop] = useState<RevistaObj>(defaultRevista);
  const [load, setLoad] = useState(false as boolean);
  const [view, setView] = useState(false as boolean);
  const [firstCharge, setFirstCharge] = useState(true);
  const [firstCharge2, setFirstCharge2] = useState(true);
  const [firstCharge3, setFirstCharge3] = useState(true);

  const retrieveRevistas = (year: number) => {
    RevistaService.retrieveRevistas(year)
      .then((response) => {
        if (response.data.error === true) {
          if (firstCharge) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setView(false);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'WARNING');
        } else {
          setRevistasData(response.data.pojos);
        }
        setFirstCharge(false);
      })
      .catch(() => {
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };
  const retrieveRevistasActual = (revista: RevistaObj) => {
    RevistaService.retrieveRevistasActual(
      yearSelectActual,
      moment(revista.fechaInsercion).month() + 1,
    )
      .then((response) => {
        if (response.data.error === true) {
          if (firstCharge2) {
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          }
          setView(false);
          addErrorBack(response.data);
        } else {
          setRevistaTop(response.data.pojo);
        }
        setFirstCharge2(false);
      })
      .catch(() => {
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const retrieveYears = () => {
    RevistaService.retrieveYears()
      .then((r) => {
        setYears(r.data);
        const yearSession = parseInt(
          sessionStorage.getItem('yearRevistas') as string,
          10,
        );
        if (yearSession === 0) {
          sessionStorage.setItem('yearRevistas', r.data[0]);
        }
        RevistaService.retrieveRevistas(
          yearSelectActual > 0 ? yearSelectActual : r.data[0],
        )
          .then((response) => {
            if (response.data.error === true) {
              if (firstCharge3) {
                addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
              }
              setView(false);
              addErrorBack(response.data);
            } else {
              setView(true);
              setRevistasData(response.data.pojos);
              if (response.data.pojos && response.data.pojos.length) {
                const revistaSelect = sessionStorage.getItem('revistaSelect');
                if (revistaSelect === 'no-select') {
                  setRevistaTop(response.data.pojos[0]);
                } else if (revistaSelect != null) {
                  retrieveRevistasActual(JSON.parse(revistaSelect));
                }
              }
              setFirstCharge3(false);
            }
          })
          .catch(() => {
            setView(false);
            addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
          });
      })
      .catch(() => {
        setView(false);
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  const selectHandler = (e: number) => {
    retrieveRevistas(e);
  };

  useEffect(() => {
    if (dataUser.user.token !== '') {
      if (!load) {
        setLoad(true);
        retrieveYears();
      }
      setYearSelectActual(
        parseInt(sessionStorage.getItem('yearRevistas') as string, 10),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUser.user.token, revistasData, revistaTop, years]);

  useEffect(() => {
    if (dataUser.user.token !== '') retrieveYears();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language]);

  const selectHandlerIssuu = (data: RevistaObj) => {
    sessionStorage.setItem('revistaSelect', JSON.stringify(data));
    window.scrollTo(0, 0);
    setRevistaTop(data);
  };

  return (
    <>
      <section
        id="banda-top"
        className="o-section--no-padding-top section--background"
      >
        <div className="container">
          <div className="cabecera-seccion">
            <div className="titulo-seccion">
              <h1 className="titulo-seccion__title">
                {t('revistas.title-caprabo')}
              </h1>
            </div>
          </div>
        </div>
      </section>
      {(() => {
        if (view) {
          return (
            <section className="o-section--medium">
              <div className="container-inner__small u-margin-bottom-huge">
                {revistaTop && <RevistasIssuu revista={revistaTop} />}

                <div className="listado__revista--intro">
                  <h2 className="titulo-pagina u-text-brand u-text-center u-margin-bottom-medium">
                    {t('revistas.numerosAnteriores')}
                  </h2>

                  <p className="u-font-base u-margin-bottom-huge">
                    {t('revistas.texto')}
                  </p>

                  <RevistasFilter onChange={selectHandler} years={years} />
                </div>
              </div>

              <div className="container">
                <div className="listado__revista">
                  <div className="row">
                    {revistasData &&
                      revistasData.map((revista) => (
                        <RevistasItems
                          revista={revista}
                          key={revista.idRevista}
                          onSelectItem={selectHandlerIssuu}
                        />
                      ))}
                  </div>
                </div>
              </div>
            </section>
          );
        }
        return <NoData />;
      })()}{' '}
    </>
  );
};

export default RevistasCaprabo;
